import { Actions } from "../constants/actionTypes";

export function plansReducer(state = {}, action) {
  if (action.type === Actions.SET_ALL_PLANS) {
    return {
      ...state,
      allPlans: action.data,
    };
  } else if (action.type === Actions.SET_GET_SEPCIFIC_PLAN) {
    return {
      ...state,
      specificPlan: action.data,
    };
  } else if (action.type === Actions.SET_ALL_LICENSE) {
    return {
      ...state,
      allLicenses: action.data,
    };
  } else if (action.type === Actions.SET_PLAN) {
    return {
      ...state,
      selectedPlan: action.data,
    };
  }
  return { ...state };
}
